







































import { Vue, Component, Prop } from 'vue-property-decorator';

import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';

@Component({
  components: { TeamLogo }
})
export default class Points extends Vue {
  @Prop() private title!: string | null;
  @Prop() private points!: object;
}
